import { render, staticRenderFns } from "./ExplainPage.vue?vue&type=template&id=0c688dd8&scoped=true&"
import script from "./ExplainPage.vue?vue&type=script&lang=js&"
export * from "./ExplainPage.vue?vue&type=script&lang=js&"
import style0 from "./ExplainPage.vue?vue&type=style&index=0&id=0c688dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c688dd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
